<app-homepage-header pageName="{{'home-page-content.prices' | translate}}"></app-homepage-header>
<div class="subscription-plan-container">
  <div class="subscription-plan-background-wrapper">
    <img src="/assets/subscription-plan/bg.png" alt="background" class="subscription-plan-background">
  </div>
  <div class="text-container">
    <div class="title-container">
      <div class="title" [ngClass]="{'title_am': currentLang === Language.HY, 'title_ru': currentLang === Language.RU}">
        {{ 'subscription_plan_content.title' | translate }}
      </div>
      <div class="small-title-container">
        <div class="small-title"
             [ngClass]="{'small-title-ru': currentLang === Language.RU, 'small-title-am': currentLang === Language.HY}">
          {{ 'subscription_plan_content.small_title' | translate }}
        </div>
      </div>
    </div>
    <br>
    <div class="toggle-container">
      <button class="toggle-button"
              [class.active]="isIndividuals"
              (click)="togglePlan(true)">
        @if (isIndividuals) {
          <img src="/assets/subscription-plan/checkmark.svg" alt="checkmark" class="checkmark-container">
        }
        {{ 'subscription_plan_content.individuals' | translate }}
      </button>
      <button class="toggle-button"
              [class.active]="!isIndividuals"
              (click)="togglePlan(false)">
        @if (!isIndividuals) {
          <img src="/assets/subscription-plan/checkmark.svg" alt="checkmark" class="checkmark-container">
        }
        {{ 'subscription_plan_content.teams' | translate }}
      </button>
    </div>
    <br>
    <br>
    <app-toggle [inputId]="'subscription-time-toggle'"
                [data]="ToggleElModel.create({id: 1, leftText:'subscription_plan_content.monthly' | translate, rightText:'subscription_plan_content.yearly' | translate, additionalRightText:'subscription_plan_content.save_for' | translate})"
                (onChange)="toggleTerm($event)"></app-toggle>
    <br>
    <br>
    <br>
    <div class="subscription-plan-cards-container">
      @if (isIndividuals) {
        @for (individualsSubscriptionPlans of subscriptionIndividualsPlanInfoModel; track individualsSubscriptionPlans) {
          <app-subscription-plan-card [isFromUserPage] = "false"
            [subscriptionPlanInfoModel]="individualsSubscriptionPlans"></app-subscription-plan-card>
        }
      } @else {
        @for (teamsSubscriptionPlans of subscriptionTeamsPlanInfoModel; track teamsSubscriptionPlans) {
          <app-subscription-plan-card  [isFromUserPage] = "false" [subscriptionPlanInfoModel]="teamsSubscriptionPlans"></app-subscription-plan-card>
        }
      }
    </div>
  </div>
  <app-frequently-asked-questions></app-frequently-asked-questions>
  <app-footer class="w-100"></app-footer>
</div>
